<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-12">
                    <np-checkbox v-if="!isView && !isBundlePackage"
                            :id="`${id}_selected`"
                            :name="`${name}[selected]`"
                            :no-wrapper="true"
                            :required="!!isOnline && !hasSelectedOnlineServices"
                            :disabled="itemIsDisabled(bundle_item) || !!bundle_item.is_disabled"
                            :description="bundle_item.service.service_name"
                            v-model="bundle_item.is_boarding_activated"
                            @change="setServiceFeatures($event)"
                            :on-selected="function() {
                                                                      if(!bundle_item.terminal_quantity > 0 ){
                                                                        bundle_item.terminal_quantity = 1;
                                                                        bundle_item.selected = true;
                                                                        bundle_item.is_boarding_activated = '1';
                                                                      }
                                                                      if(!!isOnline){
                                                                          $emit('online-service-toggled', bundle_item)
                                                                      }

                                                                    }"
                            :on-deselected="() => {bundle_item.terminal_quantity = 0; bundle_item.selected = false;
                            bundle_item.is_boarding_activated = '0';
                            if(objectIsNotEmpty(bundle_item.service_features)){
                              getBundleItemFeatures(bundle_item).forEach(obj => {
                                    obj.selected = '';
                              obj.value = '';
                            })
                            }

                            }">
                    </np-checkbox>
                    <span v-else>   {{bundle_item.service.service_name}}</span>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="marginBottom5"  v-if="itemHasDescription(bundle_item)">
                        <span class="labelLook boldText">{{lang('description')}}</span>
                        <np-show-less
                            :id="id"
                            :description="bundle_item.service.service_description">
                        </np-show-less>
                    </div>
                </div>
                <div class="col-12 col-sm-5 col-md-7 col-lg-7" v-if="itemHasFeatures(bundle_item)">
<!--                  <span class="labelLook boldText">{{lang('features')}}</span>-->
                  <template v-for="(feature, feature_idx) in getBundleItemFeatures(bundle_item)">
                    <div class="row marginTop5" v-if="feature.is_selectable && !isView">
                      <div class="col-md-12">
                        <np-checkbox
                            :no-wrapper="true"
                            ref="equipment_feature"
                            :name="`${name}[feature][${feature_idx}][selected]`"
                            :id="`${id}_feature_${feature_idx}_selected`"
                            :value="feature.feature_external_id"
                            @change="featureIsSelected(feature)"
                            :aria-label="feature.feature_name"
                            :disabled="bundle_item.is_boarding_activated != '1' || feature.is_required === '1'"
                            :required="feature.is_required === '1'"
                            :description="feature.feature_name"
                            :help-text="!!feature.help_text ? feature.help_text : ''"
                            :on-deselected=" () => feature.value = ''"
                            v-model="feature.selected">
                        </np-checkbox>
                      </div>
                      <div class="col-md-12">
                        <np-input
                            v-if="feature.feature_input_type === types.TEXT"
                            :label="feature.feature_name"
                            :aria-label="feature.feature_name"
                            :name="`${name}[feature][${feature_idx}][value]`"
                            :id="`${id}_feature_${feature_idx}_value`"
                            :rules="[]"
                            :required="feature.selected === '1'"
                            :check_config="false"
                            :help-text="!!feature.help_text ? feature.help_text : ''"
                            ref="equipment_feature_value"
                            :minlength="feature.minimum"
                            :maxlength="feature.maximum"
                            :disabled="feature.selected !== '1'"
                            :no-wrapper="true"
                            v-model="feature.value">
                        </np-input>
                        <np-input
                            v-else-if="feature.feature_input_type === types.NUMERIC"
                            :label="feature.feature_name"
                            :aria-label="feature.feature_name"
                            :name="`${name}[feature][${feature_idx}][value]`"
                            :id="`${id}_feature_${feature_idx}_value`"
                            :rules="['numeric']"
                            :required="feature.selected === '1'"
                            :check_config="false"
                            :help-text="!!feature.help_text ? feature.help_text : ''"
                            ref="equipment_feature_value"
                            :min="feature.minimum"
                            :max="feature.maximum"
                            :disabled="feature.selected !== '1'"
                            :no-wrapper="true"
                            v-model="feature.value">
                        </np-input>

                        <np-select2
                            v-else-if="feature.feature_input_type === types.LIST"
                            :label="feature.feature_name"
                            :aria-label="feature.feature_name"
                            :name="`${name}[feature][${feature_idx}][value]`"
                            :id="`${id}_feature_${feature_idx}_value`"
                            :show-label="true"
                            ref="equipment_feature_value"
                            :parameters="getFeatureList(feature)"
                            :required="feature.selected === '1'"
                            :check_config="false"
                            :no-wrapper="true"
                            :multi="false"
                            :help-text="!!feature.help_text ? feature.help_text : ''"
                            :disabled="feature.selected !== '1' ||bundle_item.is_boarding_activated !== '1'"
                            v-model="feature.value">
                        </np-select2>
                      </div>
                    </div>
                    <ul class="row" v-else-if="feature.is_visible && isView">
                      <li class="">
                        {{feature.feature_name}} {{getFeatureValue(feature)}}
                      </li>
                    </ul>
                      <ul class="row" v-else-if="feature.is_visible">
                          <li class="">
                              {{ feature.feature_name }} {{ getFeatureValue(feature) }}
                          </li>
                      </ul>
                  </template>
                </div>
                <div class="col-12 col-sm-5 col-md-5 col-lg-5" v-if="itemHasServiceCharges(bundle_item, isView)">
                        <span class="labelLook" style="font-weight: bold">{{lang('charges')}}</span>
                      <div class="row">
                        <template v-for="(service_charge, service_charge_idx) in bundle_item.service_charges">
                          <div class="col-12" v-if="!isView">
                            <np-checkbox
                                :id="`${id}_service_charge_${service_charge_idx}_selected`"
                                :name="`${name}[service_charge][${service_charge_idx}][selected]`"
                                :no-wrapper="true"
                                :disabled="true"
                                :description="getServiceChargeDescription(service_charge)"
                                v-model="service_charge.selected">
                            </np-checkbox>
                          </div>
                          <div class="col-12" v-else-if="isView">
                              <ul class="row">
                                  <li class="">
                                      {{service_charge.service_item_name + ': '}} {{getServiceCharge(service_charge, isView)}}
                                  </li>
                              </ul>
                          </div>
                        </template>
<!--                          <div class="col-12">-->
<!--                                  <np-input-->
<!--                                          :label="lang('total')"-->
<!--                                          :id="`${id}_total`"-->
<!--                                          :name="`${name}[total]`"-->
<!--                                          :readonly="true"-->
<!--                                          :split="0.3"-->
<!--                                          :disabled="true"-->
<!--                                          :addon-on-left="true"-->
<!--                                          :value="totalSellingOptions">-->
<!--                                      <span slot="addon">{{currencySymbol}}</span>-->
<!--                                  </np-input>-->
<!--                          </div>-->
                      </div>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utilMixin from "../utils/mixins";
    import applicationMixin from "../utils/application-mixin";
    import equipmentMixin from "../utils/equipment-mixin";
    import {
        NPCheckBox,
        NPEntry,
        NPInput,
        NPNotice,
        NPRadios,
        NPResponsive,
        NPSelect2, NPShowLess,
        NPSkeleton,

    } from "netpify/components";

    export default {
        name: "equipment-services",
        mixins: [utilMixin, applicationMixin, equipmentMixin],
        components: {
            'np-entry': NPEntry,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-select2': NPSelect2,
            'np-responsive': NPResponsive,
            'np-skeleton': NPSkeleton,
            'np-checkbox': NPCheckBox,
            'np-notice': NPNotice,
            'np-show-less': NPShowLess,
        },
        props: {
            bundle: {
                default() {
                    return {}
                }
            },
            bundle_item: {
                default() {
                    return {}
                }
            },
            isStandalone:Boolean,
            id: {
                default(){
                    return 'quote' + Math.random().toString()
                }
            },
            name: {
                default(){
                    return 'quote' + Math.random().toString()
                }
            },
            isOnline: Boolean,
            isView: Boolean,
            isBundlePackage: Boolean,
            bundlePackageSelected: Boolean,
        },
        computed: {
            totalSellingOptions: function () {
                let total = 0.00;

                if (this.objectIsNotEmpty(this.bundle_item.service_charges)) {
                    let selected_service_charges = this.bundle_item.service_charges.filter(obj => obj.selected === '1');

                    selected_service_charges.forEach(obj => {
                        if (obj.service_frequency === '1') {
                            let value = !!obj.default_base_charge && obj.default_base_charge !== '' ? obj.default_base_charge :
                                !!obj.maximum_base_charge && obj.maximum_base_charge !== '' ? obj.maximum_base_charge : 0.00;
                            total = parseFloat(total) + parseFloat(value)
                        }
                    })
                }

                return this.convertToDecimal(total);
            }
        },
        mounted(){
            console.log('service mounted')
            if(this.bundle_item.is_boarding_activated === '1' || this.bundle_item.is_mandatory === '1'){
                this.setServiceFeatures('1')
            }
        },
        methods: {
            itemHasDescription: function (bundle_item) {
                return bundle_item.service.hasOwnProperty('service_description') &&
                    bundle_item.service.service_description !== '';
            },
            itemIsDisabled: function (bundle_item) {
                return this.isView ? true : this.isBundlePackage ? true : this.equipmentIsDisabled(bundle_item);
            },
            itemIsSelected: function (bundle_item) {
                return this.isBundlePackage ? this.bundlePackageSelected ? '1' : '0' : this.equipmentIsSelected(bundle_item);
            },
            getServiceChargeDescription: function (service_charge) {
                return service_charge.service_item_name + ' - ' + this.getServiceCharge(service_charge);
            },
            setServiceFeatures: function ($event) {
                let vm = this;
                this.resetCustomEquipmentServicesBundleItem(this.bundle, this.bundle_item, 'talechEloBundle');
                this.updateFeaturesAndCharges(this.bundle_item, $event)
                // if (this.bundle_item.hasOwnProperty('service_features') && this.bundle_item.service_features.length > 0) {
                //     this.bundle_item.service_features.forEach(feature => {
                //         // feature.disabled = $event !== '1' //enable all features is bundle is selected
                //         if (!feature.is_selectable) { //set the non-selectable features to selected
                //             feature.selected = $event
                //         }
                //         if (feature.is_required === '1'){
                //             feature.selected = $event !== '1' ? $event : '1';
                //             // feature.disabled = '1';
                //         }
                //
                //         if(feature.selected === '1'){
                //             vm.selectItem(feature, feature.is_required === '1')
                //         }
                //     })
                // }
                //
                // if (this.bundle_item.hasOwnProperty('service_charges') && this.bundle_item.service_charges.length > 0) {
                //     this.bundle_item.service_charges.forEach(charge => {
                //         // charge.disabled = $event !== '1' //enable all charges is bundle is selected
                //         // if (!charge.is_selectable) { //set the non-selectable charges to selected
                //         charge.is_selected = $event
                //         // }
                //     })
                // }
            },
            selectItem: function (item, is_required = false) {
                    //set value on select
                    item['value'] = !!item['value'] ? item['value'] : item.hasOwnProperty('collect_on_value') ?
                            item['collect_on_value'] : item['default_value'];

                    //set the disabled field based on collect_on_boarding
                    if (item['collect_on_boarding'] === this.collect_on_boarding_types.OFFER) {
                        item['disabled'] = true
                    } else if (item['collect_on_boarding'] === this.collect_on_boarding_types.CONFIG) {
                        item['disabled'] = true;
                    } else {
                        item['disabled'] = false;
                    }

                    if (!!is_required) {
                        item['is_required'] = '1';
                    }

            },
          getFeatureValue: function (feature){
            let feature_value = !!feature.value ? feature.value : feature.default_value

              if (feature.feature_input_type === this.types.LIST){
                let feature_list =  this.getFeatureList(feature);
                let matched_value = feature_list.find(obj => obj.id === feature_value);

                return !!matched_value ?  `(${matched_value.text})` : '';
              }else{
                return feature_value !== '' ? `(${feature_value})` : '';
              }
          }
        }
    }
</script>

<style scoped>
    ul:not(.nav-pills) {
        list-style: none;
    }

    li:not(.nav-item) {
        /*font-weight: lighter;*/
        /*font-size: 0.8em;*/
    }

    li:not(.nav-item):before {
        content: "\f054"; /* FontAwesome Unicode fa-chevron-right*/
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
        display: inline-block;
        margin-left: -1.3em; /* same as padding-left set on li */
        width: 1.3em; /* same as padding-left set on li */
    }

    /*.avatar-small:hover {*/
    /*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/
    /*    -ms-transform: scale(2.5); !* IE 9 *!*/
    /*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/
    /*    transform: scale(2.5);*/
    /*    cursor: pointer;*/
    /*    z-index: 99999;*/
    /*}*/

    .vue-radio-checkbox.np-checkbox.default.form-group {
        min-height: 0 !important;
    }


</style>
